import type { DocumentAmendment } from '@super-mega/server/contracts/order'

export const EMPTY_DOCUMENTS: DocumentAmendment = { confirmLegalRepresentative: false, clearPrimaryIdentity: false }

export const ENTERPRISE_KINDS = {
  prospectiveCompany: { text: '拟设立企业' },
  registeredCompany: { text: '已登记企业' },
  person: { text: '历史个人对象' }
}
